import { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import CliniciansDrawer from 'components/Clinicians/Drawer/Drawer';
import CliniciansList from 'components/Clinicians/List/List';
import ClinicianDetails from 'components/Clinicians/Details/Details';
import useCustomSelector from 'hooks/useCustomSelector';
import { cliniciansSelectors } from 'features/clinicians';

const Clinicians = () => {
  const { id } = useCustomSelector(cliniciansSelectors.getClinicianData);
  
  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <CliniciansDrawer />
      <CliniciansList />
      {!id ? <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant='h5'>Please select a provider...</Typography>
      </Box> :  <ClinicianDetails /> }
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Clinicians {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);